import { User } from 'src/types';
import * as XLSX from 'xlsx';

const sanitizeFormulaInjection = (value: unknown): unknown => {
  if (typeof value === 'string') {
    const firstChar = value.charAt(0);
    if (
      firstChar === '=' ||
      firstChar === '+' ||
      firstChar === '-' ||
      firstChar === '@'
    ) {
      return `'${value}'`;
    }
  }
  return value;
};

const sanitizeUserData = (users: User[]) => {
  return users.map((user) => {
    const sanitizedUser: Record<string, unknown> = {};
    for (const [key, value] of Object.entries(user)) {
      sanitizedUser[key] = sanitizeFormulaInjection(value);
    }
    return sanitizedUser;
  });
};

export const saveGroupCsv = (users: User[], title: string) => {
  const sanitizedUsers = sanitizeUserData(users);
  const workbook = XLSX.utils.book_new();
  const sheet = XLSX.utils.json_to_sheet(sanitizedUsers);
  XLSX.utils.book_append_sheet(workbook, sheet, 'Users');

  const fileName = title ? `${title}.csv` : 'untitled.csv';
  XLSX.writeFile(workbook, fileName, {
    bookType: 'csv',
  });
};
